<template>
  <div class="modal-overlay">
    <div class="post-modal-box">

      <NewPost
        v-if="type === 'new'"
        @close="$emit('close')"
      />

      <EditPost
        v-if="type === 'edit'"
        :serviceId="postId"
        @close="$emit('close')"
      />

        <span class="close-btn" @click="$emit('close')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M6 6L18 18"
            stroke="#000"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M18 6L6 18"
            stroke="#000"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
import NewPost from "../NewPostPage.vue";
import EditPost from "../EditPostPage.vue";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    postId: {
      type: String,
      default: null,
    },
  },

  components: {
    NewPost,
    EditPost,
  },
};
</script>

<style scoped>
.post-modal-box {
width: 1440px;
  max-width: 95%;
  height: calc(100vh - 80px);
  margin-top: 40px;         
  overflow: hidden;
  border-radius: 14px;
  padding: 0;
  position: relative;
  border: 1px solid #e0e0e0; /* very subtle gray */
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);


}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Plain translucent dim instead of backdrop-filter: blur — the blur forces
     a full-viewport re-rasterization every frame the page behind animates,
     which made scrolling/interaction inside the modal drop to ~20fps.
     `none` also neutralizes the global .modal-overlay blur from main.css. */
  background: rgba(16, 24, 40, 0.4);
  backdrop-filter: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* The wizard column (header / step body / footer) must fit inside the modal
   box: box is 100vh-80px tall and the page header inside it is 80px. Without
   this, .content-area's own calc(100vh - 80px) overflows the box and hides
   the footer buttons. */
.post-modal-box :deep(.content-area) {
  height: calc(100vh - 160px);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .modal-overlay {
    align-items: flex-start;
    padding: 0;
    overflow-y: hidden;
  }

  .post-modal-box {
    width: 100%;
    max-width: 100%;
    height: 100vh;
    height: 100dvh; /* dynamic viewport — excludes mobile browser chrome */
    max-height: 100vh;
    max-height: 100dvh;
    margin-top: 0;
    border-radius: 0;
    /* The inner .left-view scrolls; the box itself stays put so the footer
       button is always pinned to the visible bottom edge. */
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
  }

  /* PostEditPage's ≤600 rule subtracts the bottom tab bar, but this modal
     covers the bar — restore the full-height column (header pads the notch). */
  .post-modal-box :deep(.content-area) {
    height: calc(100dvh - 72px - env(safe-area-inset-top, 0px)) !important;
  }

  .close-btn {
    position: fixed !important;
    /* Keep the X below the notch/status bar on the full-screen modal */
    top: calc(10px + env(safe-area-inset-top, 0px)) !important;
    right: 10px !important;
    z-index: 10000 !important;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  }
}

</style>
